module.exports = __webpack_public_path__ + "img/activity.c5407131.svg";